import React, { useEffect, useState } from "react";
import { Pencil, Trash2 } from "lucide-react";

function CartItemRow({ item, onEdit, onDelete, formatPrice, highlightKey }) {
    const [highlight, setHighlight] = useState(false);

    useEffect(() => {
        // If this row matches the highlightKey, animate
        if (highlightKey === (item.lineId || item.id)) {
            setHighlight(true);
            const timer = setTimeout(() => setHighlight(false), 800); // highlight duration
            return () => clearTimeout(timer);
        }
    }, [highlightKey, item.lineId, item.id]);

    return (
        <div
            className="flex justify-between items-center py-1.5 last:border-none transition-colors duration-500 border-b border-dashed border-gray-300"
            style={{
                background: highlight ? 'var(--color-hover)' : 'transparent',
            }}
        >
            <p
                className="text-sm truncate"
                style={{ color: 'var(--color-text)' }}
            >
                {item.qty} x {item.name}
            </p>
            <div className="flex items-center space-x-1">
                <p
                    className="text-sm font-semibold"
                    style={{ color: 'var(--color-text)' }}
                >
                    {formatPrice(item.price * item.qty)}
                </p>
                <button
                    onClick={() => onEdit(item)}
                    className="transition-colors p-1 rounded focus:outline-none hover:bg-gray-100"
                    title="Edit item"
                    style={{ color: '#6b7280' }}
                    onMouseOver={e => e.currentTarget.style.color = 'var(--color-primary)'}
                    onMouseOut={e => e.currentTarget.style.color = '#6b7280'}
                >
                    <Pencil size={14} />
                </button>
                <button
                    onClick={onDelete}
                    className="transition-colors p-1 rounded focus:outline-none hover:bg-red-50"
                    title="Remove item"
                    style={{ color: '#6b7280' }}
                    onMouseOver={e => e.currentTarget.style.color = '#dc2626'}
                    onMouseOut={e => e.currentTarget.style.color = '#6b7280'}
                >
                    <Trash2 size={14} />
                </button>
            </div>
        </div>
    );
}

// At the bottom of src/components/POS/cart/CartItemRow.js

export default React.memo(
    CartItemRow,
    (prev, next) =>
        prev.item.qty === next.item.qty &&
        prev.item.price === next.item.price &&
        prev.highlightKey === next.highlightKey
);

